import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { AvailableExams } from '../../components/available-exams'
import { FinishedExams } from '../../components/finished-exams'
import { Achievements } from '../../components/achievements'

const Examination = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Examination
                        </Heading>
                        <Breadcrumb
                            crumbs={['Examination']}
                        />
                        <AvailableExams />
                        <FinishedExams />
                        <Achievements />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Examination
